import { Grid } from '@mui/material';
import './style.scss'
import EmployerBanner from './employerBanner';
import JobSeekerBanner from './jobSeekerBanner';
import LoginComponent from './loginComponent';

// EMPLOYER LOGIN FUNCTION 
const EmployerLogin = () => {

  const queryParams = new URLSearchParams(window.location.search);
  const rolesEmployee = queryParams.get('roles');


  return (
    <div className="SinginFormPage">
      <Grid container spacing={0}>
        <Grid item xs={12} sm={6} lg={6}>
          {rolesEmployee === 'employer' ? <EmployerBanner /> : <JobSeekerBanner />}
        </Grid>
        <Grid item xs={12} sm={6} lg={5}>
          <LoginComponent />
        </Grid>
      </Grid>
      <img src={require('../../assets/images/geo.png')} className="SignInGeoTop" alt="" />
      <img src={require('../../assets/images/geo1.png')} className="SignInGeoBottom" alt="" />
    </div>
  );
}

export default EmployerLogin;